import { useMemo } from 'react'
import { ChartOptions } from 'chart.js'
import { getMarketPricesChartOptions } from 'components/charts/market-prices/chartjs.config.ts'
import { Chart } from 'react-chartjs-2'
import { MarketPricesChartProps } from './types.ts'

const MarketPricesChartDesktop = ({ chartData, granularity, labels, setHoverDataPointIndex }: MarketPricesChartProps) => {
  // Constants
  const options = useMemo<ChartOptions<'bar'>>(
    () => getMarketPricesChartOptions({ granularity, labels, handleHoverDataPoint: setHoverDataPointIndex }),
    [granularity, labels, setHoverDataPointIndex]
  )

  return <Chart type="bar" options={options} data={chartData} />
}

export default MarketPricesChartDesktop
